export default "__VITE_ASSET__CWtSnTIT__"